@if (title && align === 'full') {
	<label class="c-progress-bar__title" for="progress" [innerHTML]="title"></label>
}
@if (title && align === 'left') {
	<label class="c-progress-bar__title c-progress-bar__title--left">
		<span class="c-progress-bar__title__progress">{{ progress }}%</span>
		<span class="c-progress-bar__title__title" [innerHTML]="title"></span>
	</label>
}
@if (progress) {
	<progress class="c-progress-bar" id="progress" [max]="maxValue" [value]="progress"></progress>
}
